import Vue from "vue";
class CarbonService {

  Remove(id) {
    return Vue.prototype.$http({
      url: "carbon/remove/" + id,
      method: "DELETE"
    });
  }

  Get(id) {
    return Vue.prototype.$http({
      url: "carbon/get?id=" + id,
      method: "GET"
    });
  }

  GetAll() {
    return Vue.prototype.$http({
      url: "carbon/get-all",
      method: "GET"
    });
  }

  New(viewModel) {
    return Vue.prototype.$http({
      url: "carbon/new",
      data: viewModel,
      method: "POST"
    });
  }

  Edit(viewModel) {
    return Vue.prototype.$http({
      url: "carbon/edit",
      data: viewModel,
      method: "PUT"
    });
  }

  GetGrid(filter) {
    return Vue.prototype.$http({
      url: "/carbon/get-grid",
      data: filter,
      method: "POST"
    });
  }
  ReportTableUpdate(file) {
    let formData = new FormData();
    formData.append("file", file);

    return Vue.prototype.$http({
      url: "carbon/report/table/update",
      data: formData,
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });

  }

  GetTotalCard(projetcs) {
    return Vue.prototype.$http({
      url: "carbon/get-total-card",
      method: "POST",
      data: { ids: projetcs },
    });
  }

  GetTop(projetcs) {
    return Vue.prototype.$http({
      url: "carbon/get-top",
      method: "POST",
      data: { ids: projetcs },
    });
  }

  GetChartPie(projetcs) {
    return Vue.prototype.$http({
      url: "carbon/get-chart-pie",
      method: "POST",
      data: { ids: projetcs },
    });
  }

  GetChartBar(projetcs) {
    return Vue.prototype.$http({
      url: "carbon/get-chart-bar",
      method: "POST",
      data: { ids: projetcs },
    });
  }

  ToPie(model, title) {
    return {
      chart: {
        type: "pie"
      },
      title: {
        text: title
      },
      tooltip: {
        headerFormat: ""
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.y:.2f}'
          }
        }
      },
      colors: ['#052c27', '#b0cb07', '#92d050'],
      series: [
        {
          minPointSize: 10,
          innerSize: "30%",
          zMin: 0,
          name: "",
          data: model
        }
      ]
    };
  }

  ToBarColum(model, title) {
    return {
        exporting: {
            chartOptions: {
                chart: {
                    width: 790 // largura em pixels da folha A4 na orientação retrato
                }
            }
        },
        scale: 0.8,
        chart: {
            type: "bar"
        },
        title: {
            text: title
        },
        xAxis: {
            categories: model.categories
        },
        yAxis: {
            min: 0,
            title: {
                text: "Kg/CO2",
            },

        },
        plotOptions: {
            bar: {
                dataLabels: {
                    enabled: true,

                }
            }
        },
        colors: ['#009933'],
        series: [
            {
                name: "",
                colorByPoint: true,
                data: model.itens
            }
        ]
    };
}
}



export default new CarbonService();
